import { createContext, useContext } from "react";

import { useBuildVersion } from "hooks/useBuildVersion";

interface BuildContextProviderProps {
  children: React.ReactNode;
}

type TBuildContextValue = any;

const BuildContext = createContext<TBuildContextValue>(
  {} as TBuildContextValue
);

const BuildContextProvider = ({ children }: BuildContextProviderProps) => {
  useBuildVersion();

  return <BuildContext.Provider value={{}}>{children}</BuildContext.Provider>;
};

export default BuildContextProvider;
export const useBuildContext = () => useContext(BuildContext);
